<template>
  <div style="padding:12px;">

      <div class="t-al-c" style="font-size: 14px;font-weight: bold;margin: 10px 0;">{{detail.tit}}</div>

    <div style="color: #7f7f7f;margin-top: 12px;margin-bottom: 24px;font-size: 12px;" class="t-al-c">
      <span class="in-bl-v-m t-al-l">作者：不难得</span> <span class="in-bl-v-m" style="margin: 0 12px;">{{detail.lastsj}}</span> <img class="in-bl-v-m" src="../assets/images/eyes.png" /> <span class="in-bl-v-m">{{ detail.djl }}</span>
    </div>

    <div class="t-al-l" style="background-color: #ececec;padding: 12px;font-size: 12px;margin-bottom: 12px;">
      摘要：{{detail.wdes}}
    </div>


      <div style="font-size: 0;margin-bottom: 12px;"><img :src="$common.polishingImg('/boot/bh_img.php?bh=' + detail.bh)" style="width: 100%;"/></div>

    <div v-html="detail.txt" class="new-content t-al-l"></div>

    <div style="height: 60px;">

    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
export default {
  data: function() {
    return {
      activeList: [],
      detail: []
    }
  },
  props: {
    classifyid:{
      type: String,
      default: ''
    }
  },
  methods:{
    goDetail(item)
    {
      this.$router.push({path:'/new_detail', query: { id: item.id }})
    },
    initPage()
    {
      common.cusHttp(this,'/boot/news.php',{action:'detail', 'id': this.$route.query.id }, 'get').then((res)=>{
        res = JSON.parse(res.data)
        if( res.status ) {
          this.detail = res.data;
        }
      })
    }
  },
  mounted()
  {
    this.initPage()
  }
}
</script>

<style>
.hello {
  background-color: #ffe;
}

.new-content img
{
  width: 100%;
}

.news-item
{
  border-bottom:1px solid rgb(230, 230, 230) ;
}
</style>